import { render, staticRenderFns } from "./DesignDashboardOrder.vue?vue&type=template&id=135ae877&scoped=true&"
import script from "./DesignDashboardOrder.vue?vue&type=script&lang=js&"
export * from "./DesignDashboardOrder.vue?vue&type=script&lang=js&"
import style0 from "./DesignDashboardOrder.vue?vue&type=style&index=0&id=135ae877&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ae877",
  null
  
)

export default component.exports